<template>
    <div class="container _container">
        <div class="containerbody">
            <div class="content">
                <el-card class="news_card">
                    <div slot="header" class="text_title">
                        <el-row>
                            <span>EVENTS</span>
                            <el-button type="text" style="float: right;padding: 3px 0;font-family: SourceHanSansCN-Regular; color: rgba(110, 110, 115, 0.93);font-size: 14px;">more</el-button>
                        </el-row>
                            
                    </div>
                    <div class="news_box">
                        <div class="news_box_item">
                            <div class="news_left">
                                    <img :src="imageUrl" class="news_img" />
                            </div>
                            <div class="news_right">
                                <div class="news_content">
                                    <div class="news_content_head">
                                        <div class="news_content_title">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                        <div class="news_content_time">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                    </div>
                                    <div class="news_content_text">
                                        Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="news_box">
                        <div class="news_box_item">
                            <div class="news_left">
                                    <img :src="imageUrl" class="news_img" />
                            </div>
                            <div class="news_right">
                                <div class="news_content">
                                    <div class="news_content_head">
                                        <div class="news_content_title">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                        <div class="news_content_time">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                    </div>
                                    <div class="news_content_text">
                                        Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
                <el-card class="news_card">
                    <div slot="header" class="text_title">
                        <el-row>
                            <span>EVENTS</span>
                            <el-button type="text" style="float: right;padding: 3px 0;font-family: SourceHanSansCN-Regular; color: rgba(110, 110, 115, 0.93);font-size: 14px;">more</el-button>
                        </el-row>
                            
                    </div>
                    <div class="news_box">
                        <div class="news_box_item">
                            <div class="news_left">
                                    <img :src="imageUrl" class="news_img" />
                            </div>
                            <div class="news_right">
                                <div class="news_content">
                                    <div class="news_content_head">
                                        <div class="news_content_title">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                        <div class="news_content_time">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                    </div>
                                    <div class="news_content_text">
                                        Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="news_box">
                        <div class="news_box_item">
                            <div class="news_left">
                                    <img :src="imageUrl" class="news_img" />
                            </div>
                            <div class="news_right">
                                <div class="news_content">
                                    <div class="news_content_head">
                                        <div class="news_content_title">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                        <div class="news_content_time">
                                            Here&nbsp;is&nbsp;the&nbsp;title
                                        </div>
                                    </div>
                                    <div class="news_content_text">
                                        Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.Here is an introduction article.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <shareDialog ref="shareDialog"></shareDialog>
    </div>
  </template>
  
  <script>
  export default {

    name: 'aboutUs',
    components: {
    },
    data(){
        return{
            imageUrl:require('@/components/eventsNews/imgs/news_img1.jpg'),

        }
    },
    methods:{
        shareClick(){
            this.$refs.shareDialog.open('Repost to Facebook',{})

        },
    }
  }
  </script>
  
  <style lang="less" scoped>
  
  // 大于800px
  @media only screen and (min-width: 800px){
      .container{
        width: 100%;
        overflow: hidden;
        .containerbody{
            width: 100%;
            // max-width:1000px ;
            background-color: rgb(249, 249, 249);
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 0;
            .content{
                width: 60%;
                margin: 0 auto;
                .text_title{
                    width: 100%;
                    // padding: 32px 0;
                    text-align: left;
                    font-family: SourceHanSansCN-Medium;
                    font-weight: 500;
                    color: rgba(51, 51, 51, 1);
                    font-size: 16px;
                    // font-weight: bold;
                }
                .news_box{
                    width: 100%;
                    // margin:0 auto;
                    .news_box_item{
                        width: 100%;
                        height: 200px;
                        margin:0 0 20px 0;
                        .news_left{
                            width: 30%;
                            height: 100%;
                            float: left;
                            .news_img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .news_right{
                            width: 68%;
                            height: 100%;
                            float: right;
                            display: flex;
                            align-items: center;
                            .news_content{
                                height: 80%;
                                width:100%;
                                margin:auto 0;
                                .news_content_head{
                                    height: 20%;
                                    width:100%;
                                    .news_content_title{
                                        float: left;
                                        color: rgba(51, 51, 51, 1);
                                        font-size: 20px;
                                        font-family: SourceHanSansCN-Medium;
                                        font-weight: 500;
                                        text-align: left;
                                    }
                                    .news_content_time{
                                        float: right;
                                        color: rgba(110, 110, 115, 1);
                                        font-size: 14px;
                                        font-family: SourceHanSansCN-Regular;
                                        font-weight: normal;
                                        text-align: justify;
                                        white-space: nowrap;
                                        line-height: 23px;
                                        margin-top: 4px;
                                    }
                                }
                                .news_content_text{
                                    color: rgba(110, 110, 115, 1);
                                    font-size: 14px;
                                    font-family: SourceHanSansCN-Regular;
                                    font-weight: normal;
                                    text-align: justify;
                                    line-height: 20px;
                                    margin-top: 12px;
                                }
                            }
                        }
                    }
                }
            }
            
            
        }
      }
      .news_card{
                margin-bottom: 12px;
               
            }
  }
  
  // 小于800px
  @media only screen and (max-width: 800px){
      .container{
      }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/eventsNews/index.vue